import BaseService from "./geral/BaseService";

const base = "AgendServAcompOS";

export default class AcompanhamentoServicosService extends BaseService {
  constructor() {
    super(base);
  }

  listar(parcidId, dataInicial, dataFinal, tipoServId, numeroBl, container, status) {
    let filtros = "?";
    if (parcidId) filtros = filtros.concat(`parcidId=${parcidId}`);
    if (dataInicial) filtros = filtros.concat(`&dataInicial=${dataInicial}`);
    if (dataFinal) filtros = filtros.concat(`&dataFinal=${dataFinal}`);
    if (tipoServId) filtros = filtros.concat(`&tipoServId=${tipoServId}`);
    if (numeroBl) filtros = filtros.concat(`&numeroBl=${numeroBl}`);
    if (container) filtros = filtros.concat(`&container=${container}`);
    if (status) filtros = filtros.concat(`&status=${status}`);
    filtros = filtros.replace("?&", "?");
    return super.httpGet(`/${base}/Listar${filtros}`);
  }

  listarClientes() {
    return super.httpGet(`/${base}/ListarCliente`);
  }

  listarGrupos() {
    return super.httpGet(`/${base}/ListarGrupos`);
  }

  listarSubgrupos(grupoServId) {
    return super.httpGet(`/${base}/ListarTipos?grupoServId=${grupoServId}`);
  }

  listarStatus() {
    return super.httpGet(`/${base}/ListarStatus`);
  }

  getAnexos(osId) {
    const q = `/${base}/ListarAnexos?osId=${encodeURIComponent(osId)}`;
    const p = `/${base}/ListarAnexos/${encodeURIComponent(osId)}`;
    
    return super.httpGet(q).then((res) => {
      if (!res || typeof res === "string") return res;
      if (res.status && res.status >= 400) return super.httpGet(p);
      return res;
    });
  }

  baixarDocumento(anexoId) {
    return super.httpGet(`/${base}/BaixarAnexo/${encodeURIComponent(anexoId)}`, true);
  }

}



// WEBPACK FOOTER //
// ./src/services/AcompanhamentoServicosService.js